export default "__VITE_ASSET__gudbJopm__"